import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import Login from './Login';
import EsqueceuSenha from './components/EsqueceuSenha';
import { CssBaseline } from '@mui/material';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LoginProvider } from './contexts/LoginContext';
import RedefinirSenha from './components/RedefinirSenha';
import ValidacaoTokenDownload from './components/ValidacaoTokenDownload';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <LoginProvider>
    <React.StrictMode>
      <CssBaseline />
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<App />} />
          <Route path='/dashboard' element={<App />} />
          <Route path='/central-backups' element={<App />} />
          <Route path='/arquivos-recentes' element={<App />} />
          <Route path='/tarefas' element={<App />} />
          <Route path='/dispositivos' element={<App />} />
          <Route path='/historicos' element={<App />} />
          <Route path='/lixeira' element={<App />} />
          <Route path='/clientes' element={<App />} />
          <Route path='/instaladores' element={<App />} />
          <Route path='/fale-conosco' element={<App />} />
          <Route path='/login' element={<Login />} />
          <Route path='/esqueceu-senha' element={<EsqueceuSenha />} />
          <Route path='/redefinir-senha' element={<RedefinirSenha />} />
          <Route path='/download-validar/:id' element={<ValidacaoTokenDownload />} />
          <Route path='*' element={<App />} />
        </Routes>
      </BrowserRouter>
    </React.StrictMode>
  </LoginProvider>
);
